<template lang="pug">
.card-body
  .row
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.promotion_id')").mb-0
        DebounceInput(
          size="sm"
          ref="promotion_id"
          required
          type="text"
          :dirty="$v.promotion_id.$dirty"
          :error="$v.promotion_id.$error"
          v-model.trim.lazy="$v.promotion_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.promotion_id" :name="$t('ui.promotion_id')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.promotion_name')").mb-0
        DebounceInput(
          size="sm"
          ref="promotion_name"
          required
          type="text"
          :dirty="$v.promotion_name.$dirty"
          :error="$v.promotion_name.$error"
          v-model.trim.lazy="$v.promotion_name.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.promotion_name" :name="$t('ui.promotion_name')")
  .row
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.claim_type')").mb-0
        ClaimTypeLookup(
          ref="claim_type"
          size="sm"
          required
          type="array"
          :dirty="$v.claim_type.$dirty"
          :error="$v.claim_type.$error"
          v-model.trim.lazy="$v.claim_type.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.claim_type" :name="$t('ui.claim_type')")
    .col-sm-12.col-md-3.col-lg-3(v-if="!['ALL DAY','NEWBIE','ONCE','DAILY FIRST DEPOSIT'].includes(claim_type)")
      template(v-if="!['DAILY'].includes(claim_type)")
        b-form-group(:label="$t('ui.claim_limit')").mb-0
          b-form-select(
            size="sm"
            :dirty="$v.claim_limit.$dirty"
            :error="$v.claim_limit.$error"
            v-model.trim.lazy="$v.claim_limit.$model"
            :disabled="loading"
          )
            option(value=0) 0
            option(v-for="i in 10" :value="i") {{ i }}
          ValidateResult(:value="$v.claim_limit" :name="$t('ui.claim_limit')")
      template(v-else)
        b-form-group(:label="$t('ui.claim_limit')").mb-0
          DebounceInput(
            size="sm"
            ref="claim_limit_daily"
            required
            type="text"
            :dirty="$v.claim_limit_daily.$dirty"
            :error="$v.claim_limit_daily.$error"
            v-model.trim.lazy="$v.claim_limit_daily.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.claim_limit_daily" :name="$t('ui.claim_limit')")
    .col-sm-12.col-md-3.col-lg-3(v-if="!['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type)")
      b-form-group(:label="$t('ui.bonus_rate_percent')").mb-0
        DebounceInput(
          size="sm"
          ref="bonus_rate"
          required
          type="text"
          :dirty="$v.bonus_rate.$dirty"
          :error="$v.bonus_rate.$error"
          v-model.trim.lazy="$v.bonus_rate.$model"
          :disabled="loading"
        )
        span.small.text-info {{ $t("message.tooltips_promo_bonus_rate") }}
        ValidateResult(:value="$v.bonus_rate" :name="$t('ui.bonus_rate_percent')")
  .row(v-if="['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(claim_type) && claim_limit > 0 && claim_limit <= 10")
    .col-sm-12.col-md-12.col-lg-12
      b-form-group(:label="$tc('ui.bonus_rate', 2)")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.mb-0(style="width: auto;")
            thead.thead-light
              tr
                th.text-center(v-for="x in Number(this.claim_limit)")
                  span {{ $t('ui.bonus_rate_' + x) }}
            tbody
              tr
                td(v-for="x in Number(this.claim_limit)")
                  div.d-flex.justify-content-center.align-items-center
                    DebounceInput.text-center(
                      size="sm"
                      :ref="'bonus_rate_' + x"
                      required
                      type="text"
                      :dirty="$v.formBonusRate['bonus_rate_' + x].$dirty"
                      :error="$v.formBonusRate['bonus_rate_' + x].$error"
                      v-model="formBonusRate['bonus_rate_' + x]"
                      :disabled="loading"
                    )
                  //- ValidateResult(:value="$v.formBonusRate['bonus_rate_' + x]" :name="$t('ui.bonus_rate_percent')")
          span.small.text-info {{ $t("message.tooltips_promo_bonus_rate") }}
  .row
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.deposit_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="min_deposit"
          required
          type="text"
          :dirty="$v.min_deposit.$dirty"
          :error="$v.min_deposit.$error"
          v-model.trim.lazy="$v.min_deposit.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.min_deposit" :name="$t('ui.deposit_amount')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.max_bonus')").mb-0
        DebounceInput(
          size="sm"
          ref="max_bonus"
          required
          type="text"
          :dirty="$v.max_bonus.$dirty"
          :error="$v.max_bonus.$error"
          v-model.trim.lazy="$v.max_bonus.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.max_bonus" :name="$t('ui.max_bonus')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.rollover')").mb-0
        DebounceInput(
          size="sm"
          ref="rollover"
          type="text"
          :dirty="$v.rollover.$dirty"
          :error="$v.rollover.$error"
          v-model.trim.lazy="$v.rollover.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.criteria')").mb-0
        VipCriteriaList(
          ref="criteria"
          size="sm"
          required
          type="array"
          :dirty="$v.criteria.$dirty"
          :error="$v.criteria.$error"
          v-model.trim.lazy="$v.criteria.$model"
          :disabled="loading"
          :hideOpt="hideOpt"
        )
        ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
  .row
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.withhold_bonus')").mb-2
        div.d-flex
          label.custom-switch
            input.custom-switch-input(
              type="checkbox"
              required
              :dirty="$v.withhold_bonus.$dirty"
              :error="$v.withhold_bonus.$error"
              v-model.trim.lazy="$v.withhold_bonus.$model"
              :disabled="loading"
            )
            span.custom-switch-indicator          
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.withhold_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="withhold_amount"
          required
          type="text"
          :dirty="$v.withhold_amount.$dirty"
          :error="$v.withhold_amount.$error"
          v-model.trim.lazy="$v.withhold_amount.$model"
          :disabled="loading || withhold_bonus"
        )
        ValidateResult(:value="$v.withhold_amount" :name="$t('ui.withhold_amount')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
        DebounceInput(
          size="sm"
          ref="max_withdraw_amount"
          required
          type="text"
          :dirty="$v.max_withdraw_amount.$dirty"
          :error="$v.max_withdraw_amount.$error"
          v-model.trim.lazy="$v.max_withdraw_amount.$model"
          :disabled="loading || max_withdraw_multiple > 0"
        )
        ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.max_withdraw_multiple')").mb-0
        DebounceInput(
          size="sm"
          ref="max_withdraw_multiple"
          required
          type="text"
          :dirty="$v.max_withdraw_multiple.$dirty"
          :error="$v.max_withdraw_multiple.$error"
          v-model.trim.lazy="$v.max_withdraw_multiple.$model"
          :disabled="loading || max_withdraw_amount > 0"
        )
        ValidateResult(:value="$v.max_withdraw_multiple" :name="$t('ui.max_withdraw_multiple')")
  .row
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.start_date')").mb-0
        b-input-group(size="sm")
          date-picker.form-control-sm(
            ref="start_date"
            :config="localeDate"
            :dirty="$v.start_date.$dirty"
            :error="$v.start_date.$error"
            v-model.trim.lazy="$v.start_date.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.start_date" :name="$t('ui.start_date')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.start_time')").mb-0
        b-input-group(size="sm")
          date-picker.form-control-sm(
            ref="start_time"
            :config="localeTime"
            :dirty="$v.start_time.$dirty"
            :error="$v.start_time.$error"
            v-model.trim.lazy="$v.start_time.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.start_time" :name="$t('ui.start_time')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.end_date')").mb-0
        b-input-group(size="sm")
          date-picker.form-control-sm(
            ref="end_date"
            :config="localeDate"
            :dirty="$v.end_date.$dirty"
            :error="$v.end_date.$error"
            v-model.trim.lazy="$v.end_date.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.end_date" :name="$t('ui.end_date')")
    .col-sm-12.col-md-3.col-lg-3
      b-form-group(:label="$t('ui.end_time')").mb-0
        b-input-group(size="sm")
          date-picker.form-control-sm(
            ref="end_time"
            :config="localeTime"
            :dirty="$v.end_time.$dirty"
            :error="$v.end_time.$error"
            v-model.trim.lazy="$v.end_time.$model"
            :disabled="loading"
          )
        ValidateResult(:value="$v.end_time" :name="$t('ui.end_time')")
  .row
    .col-sm-12.col-md-12.col-lg-12
      b-form-group(:label="$tc('ui.day', 2)")
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.w-100
            thead.thead-light
              tr
                th.text-center
                  span {{ $t('ui.monday') }}
                th.text-center
                  span {{ $t('ui.tuesday') }}
                th.text-center
                  span {{ $t('ui.wednesday') }}
                th.text-center
                  span {{ $t('ui.thursday') }}
                th.text-center
                  span {{ $t('ui.friday') }}
                th.text-center
                  span {{ $t('ui.saturday') }}
                th.text-center
                  span {{ $t('ui.sunday') }}
            tbody
              tr
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.monday.$dirty"
                        :error="$v.monday.$error"
                        v-model.trim.lazy="$v.monday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.monday" :name="$t('ui.monday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.tuesday.$dirty"
                        :error="$v.tuesday.$error"
                        v-model.trim.lazy="$v.tuesday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.tuesday" :name="$t('ui.tuesday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.wednesday.$dirty"
                        :error="$v.wednesday.$error"
                        v-model.trim.lazy="$v.wednesday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.wednesday" :name="$t('ui.wednesday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.thursday.$dirty"
                        :error="$v.thursday.$error"
                        v-model.trim.lazy="$v.thursday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator                      
                  ValidateResult(:value="$v.thursday" :name="$t('ui.thursday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.friday.$dirty"
                        :error="$v.friday.$error"
                        v-model.trim.lazy="$v.friday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.friday" :name="$t('ui.friday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.saturday.$dirty"
                        :error="$v.saturday.$error"
                        v-model.trim.lazy="$v.saturday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.saturday" :name="$t('ui.saturday')")
                td
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(
                        type="checkbox"
                        required
                        :dirty="$v.sunday.$dirty"
                        :error="$v.sunday.$error"
                        v-model.trim.lazy="$v.sunday.$model"
                        :disabled="loading"
                      )
                      span.custom-switch-indicator
                  ValidateResult(:value="$v.sunday" :name="$t('ui.sunday')")
  .row
    .col
      .d-flex.flex-wrap.align-items-start
        b-form-group.mb-0.mr-5.w-20(:label="$t('ui.promotion_type')")
          PromotionType(
            ref="promotion_type"
            size="sm"
            required
            type="array"
            :dirty="$v.promotion_type.$dirty"
            :error="$v.promotion_type.$error"
            v-model.trim.lazy="$v.promotion_type.$model"
            :disabled="loading"
          )
          ValidateResult(:value="$v.promotion_type" :name="$t('ui.promotion_type')")
        template(v-if="['CUSTOM'].includes(promotion_type)")
          b-form-group.mb-2.mr-5(:label="$t('ui.send_message')")
            label.custom-switch
              input.custom-switch-input(
                type="checkbox"
                required
                :dirty="$v.send_message.$dirty"
                :error="$v.send_message.$error"
                v-model.trim.lazy="$v.send_message.$model"
                :disabled="loading"
              )
              span.custom-switch-indicator
          b-form-group.mb-2.mr-5(v-if="send_message == true" :label="$t('ui.msg_greeting')")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="include_greeting" :disable="loading")
              span.custom-switch-indicator
  .row(v-if="['CUSTOM'].includes(promotion_type) && send_message == true")
    .col-sm-12.col-md-12.col-lg-12
      b-form-group(:label="$t('ui.msg_title')").mb-0
        DebounceInput(
          size="sm"
          ref="title"
          required
          type="text"
          :dirty="$v.title.$dirty"
          :error="$v.title.$error"
          v-model.trim.lazy="$v.title.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.title" :name="$t('ui.msg_title')")
  .row(v-if="['CUSTOM'].includes(promotion_type) && send_message == true")
    .col-sm-12.col-md-12.col-lg-12
      b-form-group(:label="$t('ui.msg_body')" :disable="loading").mb-3
        b-form-textarea(
          :dirty="$v.body.$dirty"
          :error="$v.body.$error"
          v-model.trim.lazy="$v.body.$model"
          rows="3"
          max-rows="3"
          :disabled="loading"
          )
        ValidateResult(:value="$v.body" :name="$t('ui.msg_body')")
  //- .row(v-if="['DEPOSIT'].includes(promotion_type)")
  //-   .col-sm-12.col-md-12.col-lg-12
  //-     b-form-group(:label="$t('ui.vip')").mb-0
  //-       table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(style="width: auto;")
  //-         tr
  //-           th(colspan="2")
  //-             b-form-checkbox(v-model="allSelectedVIP" @change="selectAllVIP")
  //-               span.font-weight-bold {{ allSelectedVIP  ? $t('ui.unselect_all') : $t('ui.select_all') }}
  //-         tr(v-for="(row, rowIndex) in rowsVIPList" :key="rowIndex")
  //-           td(v-for='(p, itemIndex) in row' :key="itemIndex")
  //-             b-form-checkbox(v-model="vip_list" :value='p.value') {{ p.text }}
  //-       ValidateResult(:value="$v.vip_list" :name="$t('ui.vip')") 
  .row(v-if="['CUSTOM'].includes(promotion_type)")
    .col-sm-12.col-md-12.col-lg-12
      b-form-group
        label {{ $t('ui.member_list') }}
        i.fa.fa-info-circle.text-info.ml-2(:title="$t('message.tooltips_promo_member_custom')")
        b-form-textarea.col-12(
          ref="member_list"
          size="sm"
          required
          :dirty="$v.member_list.$dirty"
          :error="$v.member_list.$error"
          v-model.trim.lazy="$v.member_list.$model"
          rows="10"
          max-rows="10"
          trim=true
          :disabled="loading"
          @paste="handlePaste"
        )
      ValidateResult(:value="$v.member_list" :name="$t('ui.member_list')")
  .row
    .col-sm-12.col-md-6.col-lg-3(v-if="['DEPOSIT'].includes(promotion_type)")
      b-form-group(:label="$t('ui.vip')" style="overflow: hidden scroll; height: 45vh;").mb-0
        //- table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        .table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle 
            thead
              tr
                th.col-checkbox
                  b-form-checkbox(v-model="allSelectedVIP" @change="selectAllVIP")
                    span.font-weight-bold {{ allSelectedVIP  ? $t('ui.unselect_all') : $t('ui.select_all') }}
            tbody
              tr(v-for='(p, index) in vipList')
                td.col-checkbox
                  b-form-checkbox(v-model="vip_list" :value='p.value') {{ p.text }}
          ValidateResult(:value="$v.vip_list" :name="$t('ui.vip')")
    //- .col-sm-12.col-md-6.col-lg-3
    //-   b-form-group(:label="$t('ui.payment_option')" style="overflow: hidden scroll; height: 45vh;").mb-0
    //-     table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
    //-       thead.thead-light
    //-         tr
    //-           th.col-checkbox
    //-             b-form-checkbox(v-model="allSelectedPO" @change="selectAllPO")
    //-               span.font-weight-bold {{ allSelectedPO  ? $t('ui.unselect_all') : $t('ui.select_all') }}
    //-       tbody
    //-         tr(v-for='(p, index) in paymentOptionList')
    //-           td.col-checkbox
    //-             b-form-checkbox(v-model="payment_option_list" :value='p.value') {{ p.text }}
    //-   ValidateResult(:value="$v.payment_option_list" :name="$t('ui.payment_option')")
    //- .col-sm-12.col-md-9.col-lg-4
    //-   b-form-group(:label="$t('ui.payment_gateway')" style="overflow: hidden scroll; height: 45vh;").mb-0
    //-     table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
    //-       tr
    //-         th(colspan="3")
    //-           b-form-checkbox(v-model="allSelectedPG" @change="selectAllPG")
    //-             span.font-weight-bold {{ allSelectedPG  ? $t('ui.unselect_all') : $t('ui.select_all') }}
    //-       tr(v-for="(row, rowIndex) in rowsPGList" :key="rowIndex")
    //-         td(v-for='(p, itemIndex) in row' :key="itemIndex")
    //-           b-form-checkbox(v-model="payment_gateway_list" :value='p.value') {{ p.value }}
    //-   ValidateResult(:value="$v.payment_gateway_list" :name="$t('ui.payment_gateway_list')")
    .col-sm-12.col-md-12.col-lg-6
      b-form-group(:label="$t('ui.provider_list')" style="overflow: hidden scroll; height: 45vh;").mb-0
        table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
          tr
            th.text-center.col-checkbox(colspan=3)
              .d-flex
                .custom-checkbox.custom-control
                  input#all-provider.custom-control-input(type='checkbox' data-checkboxes="allSelected" data-checkbox-role="dad" @change="selectAll(0,$event)" v-model="allSelected[0]" :disabled="loading")
                  label.custom-control-label(for='all-provider') {{ $t('ui.all') }}
                template(v-for="(cat, index) in providerCatList")
                  .custom-checkbox.custom-control
                    input.custom-control-input(
                      type="checkbox"
                      :id="'all-' + cat.toLowerCase()"
                      v-model="allSelected[index + 1]"
                      @change="selectAll(index + 1,$event)"
                      :disabled="loading"
                    )
                    label.custom-control-label(:for="'all-' + cat.toLowerCase()") {{ $t('ui.' + cat.toLowerCase()) }}
          tr(v-for="(row, rowIndex) in rowsPList" :key="rowIndex")
            td.col-checkbox(v-for='(p, itemIndex) in row' :key="itemIndex")
              b-form-checkbox(v-model="provider_list" :value='p.value') {{ p.text }}
      ValidateResult(:value="$v.provider_list" :name="$t('ui.provider_list')")
  .row
    .col
      b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  .col-12
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" size="xs" variant="danger" type="button" isModal=false @click="cancel()")
    SubmitButton.ml-1(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" size="xs" variant="success" isModal=false @click="submit()")

</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";
import ClaimTypeLookup from "@/library/ClaimTypeLookup";
import PromotionType from "@/library/PromotionType";
import PromotionGroupLookup from "@/library/PromotionGroupLookup";
import BankProviderLookup from "@/library/BankProviderLookup";
import VipLookup from "@/library/VipLookup";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
const atLeastOneProvider = (value) => value.length > 0;
const atLeastOnePaymentOption = (value) => value.length > 0;
// const atLeastOnePaymentGateway = (value) => value.length > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList,
    ClaimTypeLookup,
    PromotionType,
    PromotionGroupLookup,
    BankProviderLookup,
    VipLookup
  },
  props: {
  },
  data() {
    return {
      promotion_id: "",
      promotion_name: "",
      claim_type: "",
      min_deposit: "",
      bonus_rate: "",
      max_bonus: 0,
      rollover: "",
      criteria: "",
      withhold_bonus: false,
      withhold_amount: 0,
      max_withdraw_amount: 0,
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      end_date: this.$moment(new Date).format('YYYY-MM-DD'),
      start_time: "00:00:00",
      end_time: "23:59:59",
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: true,
      sunday: true,
      claim_limit: 0,
      claim_limit_daily: 0,
      max_withdraw_multiple: 0,
      provider_list: [],
      providerList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
      hideOpt: ['DEPOSIT'],

      // payment_option_list: [],
      paymentOptionList: [],
      allSelectedPO: true,
      promotion_type: "",
      allSelectedPG: true,
      // payment_gateway_list: [],
      paymentGatewayList: [],
      allSelectedVIP: true,
      vip_list: [],
      vipList: [],
      member_list: "",
      formBonusRate: {},
      settingList: [],
      allSelected: {},
      providerCatList: [],
      prefixMap: {},
      send_message: false,
      title: "",
      body: "",
      include_greeting: false
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    // rowsPGList() {
    //   const rows = [];
    //   for (let i = 0; i < this.paymentGatewayList.length; i += 3) {
    //     rows.push(this.paymentGatewayList.slice(i, i + 3));
    //   }
    //   return rows;
    // },
    rowsPList() {
      const rows = [];
      for (let i = 0; i < this.providerList.length; i += 3) {
        rows.push(this.providerList.slice(i, i + 3));
      }
      return rows;
    },
    rowsVIPList() {
      const rows = [];
      for (let i = 0; i < this.vipList.length; i += 8) {
        rows.push(this.vipList.slice(i, i + 8));
      }
      return rows;
    },
  },
  watch: {
    provider_list: {
      handler(newValue) {
        const val = (newValue.length === this.providerList.length && this.providerList.length > 0)

        const checkGroupSelected = prefix => {
          const items = this.providerList.filter(item => item.category === prefix)
          return items.length > 0 && items.every(item => newValue.includes(item.value))
        }

        Object.keys(this.allSelected).forEach(k => {
          const num = Number(k)

          // master
          if (num === 0) {
            this.$set(this.allSelected, 0, val)
          }
          // others
          else {
            this.$set(this.allSelected, num, checkGroupSelected(this.providerCatList[num-1]))
          }
        })
      },
      deep: true
    },
    // payment_option_list(newValue) {
    //   if (newValue.length === 0)
    //     this.allSelectedPO = false;
    //   else if (newValue.length === this.paymentOptionList.length)
    //     this.allSelectedPO = true;
    //   else
    //     this.allSelectedPO = false;
    // },
    // payment_gateway_list(newValue, oldValue) {
    //   if (newValue.length === 0)
    //     this.allSelectedPG = false;
    //   else if (newValue.length === this.paymentGatewayList.length)
    //     this.allSelectedPG = true;
    //   else
    //     this.allSelectedPG = false;
    // },
    vip_list(newValue) {
      if (newValue.length === 0)
        this.allSelectedVIP = false;
      else if (newValue.length === this.vipList.length)
        this.allSelectedVIP = true;
      else
        this.allSelectedVIP = false;
    },
    withhold_bonus(newVal) {
      if(newVal)
        this.withhold_amount = 0
    },
    claim_type(newVal) {
      if(['ALL DAY','NEWBIE','ONCE','DAILY FIRST DEPOSIT'].includes(newVal)) {
        this.claim_limit = 0
        this.claim_limit_daily = 0
      }

      if(['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(newVal))
        this.bonus_rate = 0
    },
    promotion_type(newVal) {
      if(['CUSTOM'].includes(newVal))
        this.vip_list = []

      if(['DEPOSIT'].includes(newVal))
        this.member_list = ""

      if(['ALL'].includes(newVal)) {
        this.member_list = ""
        this.vip_list = []
      }
    }
  },
  mounted: function() {
    this.getProviderList();
    // this.getPaymentOptionList();
    this.getOperatorSettingList();
    // this.getPaymentProviderList();
    this.getVIPList();
  },
  validations() {
    const formBonusRateValidations = {};
    for (let i = 1; i <= Number(this.claim_limit); i++) {
      // formBonusRateValidations[`bonus_rate_${i}`] = { required,decimal };
      formBonusRateValidations[`bonus_rate_${i}`] = { 
        required : requiredIf(function () {
          return ['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type);
        }),
        decimal
      };
    }
    return {
      formBonusRate: formBonusRateValidations,
      promotion_id: {
        required,
        alphaNum,
        minLength: minLength(6),
        maxLength: maxLength(20)
      },
      promotion_name: {
        required,
        // minLength: minLength(6),
        maxLength: maxLength(100)
      },
      claim_type: {
        required
      },
      min_deposit: {
        required,
        decimal,
        // minValue: minValue(100)
        minValue(value) {
          // return minValue(this.getMinDeposit)(value)
          return minValue(this.getMinDeposit())(value)
        }
      },
      bonus_rate: {
        required,
        decimal
      },
      max_bonus: {
        required,
        decimal
      },
      rollover: {
        required,
        integer,
        minValue: minValue(1)
      },
      criteria: {
        required
      },
      promotion_type: {
        required
      },
      withhold_bonus: {
        required
      },
      withhold_amount: {
        required,
        decimal
      },
      max_withdraw_amount: {
        required,
        decimal
      },
      start_date: {
        required
      },
      end_date: {
        required
      },
      start_time: {
        required
      },
      end_time: {
        required
      },
      monday: {
        required
      },
      tuesday: {
        required
      },
      wednesday: {
        required
      },
      thursday: {
        required
      },
      friday: {
        required
      },
      saturday: {
        required
      },
      sunday: {
        required
      },
      claim_limit: {
        integer,
        minValue(value) {
          if (['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type)) {
            return minValue(1)(value)
          } else {
            return true
          }
        },
        maxValue(value) {
          if (['DEPOSIT COUNT MONTHLY','DEPOSIT COUNT SIGNUP','DEPOSIT COUNT WEEKLY'].includes(this.claim_type)) {
            return maxValue(10)(value)
          } else {
            return true
          }
        },
        required: requiredIf(function () {
          return ['ALL DAY','NEWBIE','ONCE'].includes(this.claim_type);
        })
      },
      claim_limit_daily: {
        integer,
        required: requiredIf(function () {
          return ['ALL DAY','NEWBIE','ONCE'].includes(this.claim_type);
        })
      },
      max_withdraw_multiple: {
        required,
        integer
      },
      provider_list: {
        atLeastOneProvider,
        minLength: minLength(1)
      },
      // payment_option_list: {
      //   atLeastOnePaymentOption,
      //   minLength: minLength(1)
      // },
      // payment_gateway_list: {
      //   atLeastOnePaymentGateway,
      //   minLength: minLength(1)
      // },
      vip_list: {
        minLength(value) {
          if(['DEPOSIT'].includes(this.promotion_type)) {
            return minLength(1)(value)
          } else {
            return minLength(0)(value)
          }
        },
        required: requiredIf(function () {
          return ['DEPOSIT'].includes(this.promotion_type);
        })
      },
      promotion_type: {
        required
      },
      member_list: {
        required: requiredIf(function () {
          return ['CUSTOM'].includes(this.promotion_type);
        })
      },
      send_message : {
        required
      },
      title: {
        required: requiredIf(function () {
          return this.send_message == true;
        })
      },
      body: {
        required: requiredIf(function () {
          return this.send_message == true;
        })
      },
      include_greeting: {
        required
      }
    }
  },
  methods: {
    getMinDeposit: function() {
      for(var i = 0; i < this.settingList.length; i++) {
        if(this.settingList[i].setting_key == 'min_deposit') {
          return this.settingList[i].setting_value;
        }
      }

      return 100
    },
    getOperatorSettingList: function() {
      let url = config.operatorSettingListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handlePaste(event) {
      event.preventDefault(); // Prevent the default paste action

      // Get the pasted data from the clipboard
      let pastedData = event.clipboardData.getData('Text');

      // Remove newline characters from the pasted data
      pastedData = pastedData.replace(/\n/g, ' ');

      // Split the pasted data into an array by whitespace characters
      let dataArray = pastedData.split(' ');

      // Remove the first row if it is "ID"
      if (dataArray[0].trim() === 'ID') {
        dataArray.shift();
      }

      // Filter out any empty strings in the array
      dataArray = dataArray.map(item => item.trim()).filter(item => item !== '');

      // Join the array into a comma-separated string
      const commaSeparatedData = dataArray.join(', ');

      // Set the text area content to the comma-separated string
      this.member_list = commaSeparatedData;
    },
    selectAll: function(mode, evt) {
      const prefixMap = this.prefixMap

      // If mode is 0 (master checkbox toggled), sync all individual selections
      if (mode === 0) {
        Object.keys(this.allSelected).forEach(k => {
          this.$set(this.allSelected, k, evt.target.checked)
        })

        if (!this.allSelected[0]) {
          this.provider_list = [];
          return; // Exit early if unchecking all
        }

        // Select all providers with matching prefixes
        const allPrefixes = Object.values(prefixMap);
        this.provider_list = this.providerList
          .filter(item => allPrefixes.some(prefix => item.category == prefix))
          .map(item => item.value);

        return;
      }

      const checked = evt.target.checked
      this.$set(this.allSelected, mode, checked)

      // Individual group checkbox toggled
      const prefix = prefixMap[mode];
      const groupItems = this.providerList.filter(item => item.category == prefix);
      const groupValues = groupItems.map(item => item.value);

      if (this.allSelected[mode]) {
        // Add group values to provider_list without duplicates
        this.provider_list = Array.from(new Set([...this.provider_list, ...groupValues]));
      } else {
        // Remove only group values
        this.provider_list = this.provider_list.filter(val => !groupValues.includes(val));
      }
    },
    // selectAllPO: function() {
    //   this.payment_option_list = [];

    //   let list = this.paymentOptionList;

    //   if (this.allSelectedPO) {
    //     for(var i = 0; i < list.length; i++) {
    //       this.payment_option_list.push(list[i].value);
    //     }
    //   }
    // },
    // selectAllPG: function() {
    //   this.payment_gateway_list = [];

    //   let list = this.paymentGatewayList;

    //   if (this.allSelectedPG) {
    //     for(var i = 0; i < list.length; i++) {
    //       this.payment_gateway_list.push(list[i].value);
    //     }
    //   }
    // },
    selectAllVIP: function() {
      this.vip_list = [];

      let list = this.vipList;

      if (this.allSelectedVIP) {
        for(var i = 0; i < list.length; i++) {
          this.vip_list.push(list[i].value);
        }
      }
    },
    removeDuplicate(arr) {
      let s = new Set(arr);
      let it = s.values();
      return Array.from(it);
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.withhold_bonus && parseFloat(this.withhold_amount) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.withtholdBonusAndAmountGreaterThanZero"), "error");
          return;
        }

        if (parseFloat(this.max_withdraw_amount) > 0 && parseFloat(this.max_withdraw_multiple) > 0) {
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.maxWithdrawMultipleAndAmountGreaterThanZero"), "error");
          return;
        }

        const result = this.member_list.split(',').map(item => ({
          account_id: item.trim()
        }));

        let url = config.promotionAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          promotion_id: this.promotion_id,
          promotion_name: this.promotion_name,
          claim_type: this.claim_type,
          min_deposit: this.min_deposit,
          bonus_rate: this.bonus_rate,
          max_bonus: this.max_bonus,
          rollover: this.rollover,
          criteria: this.criteria,
          withhold_bonus: this.withhold_bonus,
          withhold_amount: this.withhold_amount,
          max_withdraw_amount: this.max_withdraw_amount,
          start_date: this.start_date,
          end_date: this.end_date,
          start_time: this.start_time,
          end_time: this.end_time,
          monday: this.monday,
          tuesday: this.tuesday,
          wednesday: this.wednesday,
          thursday: this.thursday,
          friday: this.friday,
          saturday: this.saturday,
          sunday: this.sunday,
          claim_limit: ['DAILY'].includes(this.claim_type) ? this.claim_limit_daily : this.claim_limit,
          max_withdraw_multiple: this.max_withdraw_multiple,
          promotion_type: this.promotion_type,
          member_list: this.member_list,
          member_list_promo: result,
          bonus_rate_1: this.formBonusRate['bonus_rate_1'],
          bonus_rate_2: this.formBonusRate['bonus_rate_2'],
          bonus_rate_3: this.formBonusRate['bonus_rate_3'],
          bonus_rate_4: this.formBonusRate['bonus_rate_4'],
          bonus_rate_5: this.formBonusRate['bonus_rate_5'],
          bonus_rate_6: this.formBonusRate['bonus_rate_6'],
          bonus_rate_7: this.formBonusRate['bonus_rate_7'],
          bonus_rate_8: this.formBonusRate['bonus_rate_8'],
          bonus_rate_9: this.formBonusRate['bonus_rate_9'],
          bonus_rate_10: this.formBonusRate['bonus_rate_10'],
          payment_option_list: null,
          send_message: this.send_message,
          title: this.title,
          body: this.body,
          include_greeting: this.include_greeting
        };

        if (this.provider_list.length != this.providerList.length)
          json.provider_list = this.removeDuplicate(this.provider_list.sort()).toString();

        // if (this.payment_option_list.length != this.paymentOptionList.length)
        //   json.payment_option_list = this.removeDuplicate(this.payment_option_list.sort()).toString();

        //default select all payment gateway
        // json.payment_gateway_list = null;
        // if (this.payment_gateway_list.length != this.paymentGatewayList.length)
        //   json.payment_gateway_list = this.removeDuplicate(this.payment_gateway_list.sort()).toString();

        if (this.vip_list.length != this.vipList.length)
          json.vip_list = this.removeDuplicate(this.vip_list.sort()).toString();

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("back");
                  this.$helpers.showDialog(this.$t("ui.combine.add_promo"), this.$t("message.success"), "success");
                } else {
                  // this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "add_promo", this.feedback.status);
                  // this.$emit("back");
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function() {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    getProviderList: function() {
      // this.selectedFunctions = [];
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.$set(this.allSelected, 0, false)

      let url = config.providerMaintenanceOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        is_free: false,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.providerList = response.data.dt;
                // this.getPList();

                let list = (response.data.dt || []).filter(item => item.aggregator !== "GTA");
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_name, checked: true, category: list[i].category});
                  }
                  this.providerList = result;
                } else {
                  this.providerList = [];
                }
                this.provider_list = this.providerList.map(p => p.value);

                this.setCategory();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setCategory() {
      // Build unique category list using Set (avoid duplicates)
      const catsSet = new Set()
      for (const item of this.providerList) {
        // add each category into Set (Set auto removes duplicates)
        catsSet.add(item.category)
      }

      // convert Set back to Array so we can use v-for easily
      this.providerCatList = Array.from(catsSet)

      // create checkbox state object
      // key 0 = master "select all" checkbox (initially false = unchecked)
      const obj = { 0: false }

      // for each category index, set initial checkbox state for that group also false
      this.providerCatList.forEach((_, i) => {
        obj[i + 1] = false  // i+1 means group number starting from 1
      })

      this.allSelected = obj

      this.prefixMap = this.providerCatList.reduce((o, v, idx) => {
        o[idx + 1] = v
        return o
      }, {})
    },
    getPaymentOptionList: function() {
      // this.selectedFunctions = [];
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if (list.length > 0) {
                  let result = list
                    .filter(item => item.payment_mode.toUpperCase() !== "MANUAL" && item.status == true) // Exclude "MANUAL"
                    .map(item => ({
                      value: item.payment_mode.toUpperCase(),
                      text: item.payment_desc,
                      checked: true
                    }));
                    
                  this.paymentOptionList = result;
                } else {
                  this.paymentOptionList = [];
                }
                this.payment_option_list = this.paymentOptionList.map(p => p.value);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPaymentProviderList: function() {
      let url = config.paymentProviderGbListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].provider_code.toUpperCase(), text: list[i].provider_code.toUpperCase(), checked: false});
                  }
                  this.paymentGatewayList = result;
                } else {
                  this.paymentGatewayList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVIPList: function() {
      let url = config.vipListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                let list = response.data.dt;
                if(list.length > 0){
                  let result = [];
                  for(var i = 0; i < list.length; i++) {
                    result.push({value: list[i].vip_id, text: list[i].vip_name.toUpperCase(), checked: false});
                  }
                  this.vipList = result;
                } else {
                  this.vipList = [];
                }
                this.vip_list = this.vipList.map(p => p.value);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    cancel: function() {
      this.$v.$reset();
      this.promotion_id = "";
      this.promotion_name = "";
      this.claim_type = "";
      this.min_deposit = "";
      this.bonus_rate = "";
      this.max_bonus = 0;
      this.rollover = "";
      this.criteria = "";
      this.withhold_bonus = false;
      this.withhold_amount = 0;
      this.max_withdraw_amount = 0;
      this.start_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.end_date = this.$moment(new Date).format('YYYY-MM-DD');
      this.start_time = "00:00:00";
      this.end_time = "23:59:59";
      this.monday = true;
      this.tuesday = true;
      this.wednesday = true;
      this.thursday = true;
      this.friday = true;
      this.saturday = true;
      this.sunday = true;
      this.claim_limit = 0;
      this.max_withdraw_multiple = 0;
      this.provider_list = [];
      // this.payment_option_list = [];
      // this.payment_gateway_list = [];
      this.promotion_type = "";
      this.vip_list = [];
      this.member_list = "";
      this.formBonusRate = {};
      this.providerList = [];
      this.paymentGatewayList = [];
      this.allSelected = {};
      this.providerCatList = [];
      this.prefixMap = {};
      this.send_message = false;
      this.title = "";
      this.body = "";
      this.include_greeting = false;
      this.$emit("back");
    }
  }
};
</script>
